module.exports = __webpack_public_path__ + "media/images/elenstil-def1b11aeebf6c3bd44f84e15a7ed485.webp";